import React from "react"
import { RaisedButton } from "material-ui"
import { ITaskDocument } from "../../../models"
import moment from "moment"

interface IProps {
    task: ITaskDocument
    onReload(): void
    onCompleteTask(taskId: string): void
}

const TaskTypeStandard: React.SFC<IProps> = (props: IProps) => {
    return (
        <div>
            {!props.task.Completed &&
                <RaisedButton
                    label={"Mark Task Completed"}
                    style={{ marginLeft: 60, marginTop: -8 }}
                    backgroundColor="#1181F2"
                    labelColor="white"
                    onClick={() => props.onCompleteTask(props.task.Id)}
                />
            }
            {props.task.Completed &&
                <div>
                    Completed: {moment(props.task.CompletedDate).format("hh:mma MM/DD/YYYY")}
                </div>
            }
        </div>
    )
}

export default TaskTypeStandard